import { delivery_apis } from "../ApiConst";
import { axiosInstance } from "../axios";

export const GetDeliveryPartners = async () => {
  try {
    const response = await axiosInstance.get(delivery_apis.partners(), {
      useUserToken: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetDeliveryStats = async (dateRange = "") => {
  try {
    const response = await axiosInstance.get(delivery_apis.stats(dateRange), {
      useUserToken: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetStorePreference = async () => {
  try {
    const response = await axiosInstance.get(delivery_apis.store_preference(), {
      useUserToken: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const UpdateStorePreference = async (isEnabled) => {
  try {
    const response = await axiosInstance.patch(
      delivery_apis.store_preference(),
      { is_enabled: isEnabled },
      { useUserToken: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const SyncIntegratedOrders = async () => {
  try {
    const response = await axiosInstance.post(
      delivery_apis.sync_store(),
      {},
      { useUserToken: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetMerchantDashboard = async (page = 1, pageSize = 20, status = "", dateRange = "") => {
  try {
    const response = await axiosInstance.get(
      delivery_apis.merchant_dashboard(page, pageSize, status, dateRange),
      { useUserToken: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetOrderStatus = async (orderId) => {
  try {
    const response = await axiosInstance.get(
      delivery_apis.order_status(orderId),
      { useUserToken: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const RetryOrderSync = async (orderId) => {
  try {
    const response = await axiosInstance.post(
      delivery_apis.retry_order_sync(orderId),
      {},
      { useUserToken: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const CheckServiceability = async (payload) => {
  try {
    const response = await axiosInstance.post(
      delivery_apis.serviceability(),
      payload,
      { useUserToken: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const CheckCheckoutShipping = async (payload) => {
  try {
    const response = await axiosInstance.post(
      delivery_apis.checkout_shipping(),
      payload,
      { useUserToken: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetSettlementSummary = async () => {
  try {
    const response = await axiosInstance.get(
      delivery_apis.settlement_summary(),
      { useUserToken: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetSettlementLedger = async (page = 1, pageSize = 20, eventType = "") => {
  try {
    const response = await axiosInstance.get(
      delivery_apis.settlement_ledger(page, pageSize, eventType),
      { useUserToken: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

